module.exports = __webpack_public_path__ + "img/Picture9.226bee91.jpg";